import React from 'react';

import Banner from './Banner';

const SyncSuccessBanner = () => (
    <Banner isSuccess isAutoDismissible>
        <div>You have synced successfully.</div>
    </Banner>
);

export default SyncSuccessBanner;
